export const STORE_URL = {
    PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.intelycare.clientapp&hl=en_US&gl=US',
    APP_STORE_URL: 'https://apps.apple.com/us/app/intelycare-facility/id1473318269'
};
